import { api } from './client';
import type { KS2Act, KS3Certificate, Paginated } from '@/types';

export const ks2Api = {
  async list(filters: { contract?: number; status?: string } = {}): Promise<Paginated<KS2Act>> {
    const { data } = await api.get<Paginated<KS2Act>>('/ks2/', { params: filters });
    return data;
  },
  async create(payload: Partial<KS2Act>): Promise<KS2Act> {
    const { data } = await api.post<KS2Act>('/ks2/', payload);
    return data;
  },
  async export1c(id: number): Promise<{ onec_doc_number: string }> {
    const { data } = await api.post(`/ks2/${id}/export-1c/`);
    return data;
  },
  async sign(id: number, file?: File): Promise<KS2Act> {
    const form = new FormData();
    if (file) form.append('file', file);
    const { data } = await api.post(`/ks2/${id}/sign/`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data;
  },
  async pdf(id: number): Promise<Blob> {
    const { data } = await api.get(`/ks2/${id}/pdf/`, { responseType: 'blob' });
    return data as Blob;
  },
};

export const ks3Api = {
  async list(filters: { contract?: number; status?: string } = {}): Promise<Paginated<KS3Certificate>> {
    const { data } = await api.get<Paginated<KS3Certificate>>('/ks3/', { params: filters });
    return data;
  },
  async createFromKs2(contractId: number, ks2Ids: number[], periodStart: string, periodEnd: string, number: string): Promise<KS3Certificate> {
    const { data } = await api.post<KS3Certificate>('/ks3/', {
      contract: contractId, ks2_act_ids: ks2Ids,
      period_start: periodStart, period_end: periodEnd, number,
    });
    return data;
  },
  async markPaid(id: number): Promise<KS3Certificate> {
    const { data } = await api.post<KS3Certificate>(`/ks3/${id}/mark_paid/`);
    return data;
  },
  async pdf(id: number): Promise<Blob> {
    const { data } = await api.get(`/ks3/${id}/pdf/`, { responseType: 'blob' });
    return data as Blob;
  },
};
